var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriedEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4772 17.5854C18.1282 17.5854 20.2772 15.4363 20.2772 12.7854C20.2772 10.1344 18.1282 7.98535 15.4772 7.98535C12.8263 7.98535 10.6772 10.1344 10.6772 12.7854C10.6772 15.4363 12.8263 17.5854 15.4772 17.5854Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7773 16.3855C28.7906 18.1358 28.4557 19.8713 27.792 21.4909C27.1284 23.1106 26.1492 24.582 24.9115 25.8197C23.6738 27.0574 22.2024 28.0366 20.5827 28.7002C18.9631 29.3639 17.2276 29.6988 15.4773 29.6855H15.2773C13.6789 29.654 12.1379 29.0839 10.9038 28.0676C9.66973 27.0513 8.81476 25.6482 8.47731 24.0855C7.95684 21.9482 7.00391 19.9403 5.67731 18.1855C4.27595 16.195 3.72063 13.7302 4.13299 11.331C4.54534 8.93188 5.89176 6.79396 7.87731 5.38555C9.87757 3.99268 12.2221 3.17625 14.6549 3.02547C17.0877 2.8747 19.5151 3.39537 21.672 4.5306C23.8289 5.66583 25.6324 7.37196 26.8855 9.46264C28.1386 11.5533 28.793 13.9482 28.7773 16.3855Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriedEgg);
export default __webpack_public_path__ + "static/media/fried_egg.ba891b39fc200ab4d07036db353d7856.svg";
export { ForwardRef as ReactComponent };